import React from "react";
import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";
import { smallDesktop } from "./Media";

const Row = styled.section`
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth || "98.625rem"};
    height: ${p => p.height || "auto"};
    min-height: ${p => p.minHeight || "auto"};
    display: flex;
    flex-direction: row;
    min-width: 0;
    margin-bottom: ${p => p.marginBottom || "1rem"};
    background: ${p => p.backgroundColor || portalColors.surface};
    border: 1px solid ${p => p.border || portalColors.border};
    border-radius: ${p => p.borderRadius || "16px"};
    box-shadow: ${p => p.shadow || portalColors.shadow};
    box-sizing: border-box;
    overflow: hidden;

    ${smallDesktop`
        flex-direction: column;
    `};
`;

const ContentContainer = styled.div`
    position: relative;
    flex: 1 1 50%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    text-align: left;
    line-height: 1.5;
    padding: ${p => p.contentPadding || "1rem"};
    box-sizing: border-box;
    border-top: ${p => p.$border || "none"};
    border-left: ${p => p.$border || "none"};
    border-bottom: ${p => p.$border || "none"};
    border-radius: ${p => p.$borderRadius || "0"};
    background: ${portalColors.surface};

    > * {
        max-width: 100%;
    }

    ${smallDesktop`
        width: 100%;
        border-radius: 0;
        padding: 1rem;
    `};
`;
const ImageContainer = styled.div`
    position: relative;
    flex: 1 1 50%;
    min-width: 0;
    visibility: ${p => p.imageVisibility};
    ${smallDesktop`
        display: none;
    `};
    background-image: url(${ p => p.src});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
`;

const SplitLayoutRightImage = (props) => {
    const { children, image, ...styleProps } = props;
    return (
        <Row {...styleProps}>
            <ContentContainer {...styleProps} $border={props.leftBorder} $borderRadius={props.leftBorderRadius}>
                { children }
            </ContentContainer>
            <ImageContainer imageVisibility={props.imageVisibility || "visible"} src={image}>

            </ImageContainer>
        </Row>
    );
};

export default SplitLayoutRightImage;
